import EnumerableInput from './EnumerableInput.vue';
export default EnumerableInput;